/**
 * @typedef {import("./Props").default} Props
 */

import { getTierRange } from '../../../../../utils/convertScoreToTier';
import { ScoreTiers } from '../../../../../utils/scoreTiers';
import { translate } from '../../../../Internationalization';
import BaseButton from '../../../../../shared/BaseButton/BaseButton';
import BaseForm from '../../../../../shared/Forms/BaseForm';
import FilterGroup from '../Types/FilterGroup';
import FormField from '../../../../../shared/Forms/Fields/FormField';
import InputSelect from '../../../../../shared/Forms/Inputs/InputSelect';
import React from 'react';
import SelectOptionList from 'shared/Forms/Inputs/SelectOptionList';

/** @extends	{React.Component<Props>} */
export default class MoverScoreFilter extends React.Component {
	/** @param {Props} props */
	constructor(props) {
		super(props);

		this.state = { active: false, defaultTierFilter: ScoreTiers.All };

		this._handleSubmit = this._handleSubmit.bind(this);
		this._handleReset = this._handleReset.bind(this);
	}

	/**
	 * @param {{mover_tier: string}} values
	 */
	_handleSubmit(values) {
		const [minRange, maxRange] = getTierRange(values);
		this.props.onSubmit({
			compare: 'in',
			'range[lead_scores.0.score]': `${minRange - 1};${maxRange + 1}`, // +-1 because the range is exclusive
			relation: 'and',
		});

		this.setState({ active: true });
	}

	_handleReset() {
		const query = this.props.query;

		if (query['range[lead_scores.0.score]']) {
			delete query['range[lead_scores.0.score]'];

			this.props.onSubmit({
				...query,
			});
		}

		this.setState({ active: false, defaultTierFilter: ScoreTiers.All });
	}

	/** @returns {JSX.Element} */
	render() {
		return (
			<FilterGroup
				active={this.state.active}
				locked={this.props.gated}
				title={translate('filters.title.mover_score')}
			>
				<BaseForm noRequiredText={true} onSubmit={this._handleSubmit}>
					<div className="flex flex-col gap-4">
						<FormField
							inputName={'tier_select'}
							label={translate('Select tier')}
							required={false}
						>
							<InputSelect
								defaultValue={this.state.defaultTierFilter}
								name={'mover_tier'}
								placeholder={'Select tier'}
								type="text"
							>
								<SelectOptionList values={ScoreTiers} />
							</InputSelect>
						</FormField>

						<div className="flex gap-2">
							<BaseButton
								className="w-fit"
								iconSize="small"
								size="xsmall"
								type="submit"
							>
								{translate('filters.submit')}
							</BaseButton>
							<BaseButton
								className="w-fit"
								iconSize="small"
								onClick={this._handleReset}
								outline={true}
								size="xsmall"
								type="reset"
							>
								{translate('filters.reset')}
							</BaseButton>
						</div>
					</div>
				</BaseForm>
			</FilterGroup>
		);
	}
}
